import { Link } from "react-router-dom";
import { useLanguage } from "../i18n";

export const Footer = () => {
  const { t } = useLanguage();
  const links = [
    { key: "nav_home", to: "/", testid: "footer-home-link" },
    { key: "nav_menu", to: "/menu", testid: "footer-menu-link" },
    { key: "nav_gelateria", to: "/gelateria", testid: "footer-gelateria-link" },
    { key: "nav_contacts", to: "/contatti", testid: "footer-contacts-link" },
  ];
  return (
    <footer data-testid="site-footer" className="border-t border-line bg-surface">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12 flex flex-col md:flex-row items-center justify-between gap-6">
        <Link to="/" data-testid="footer-logo" className="flex items-center gap-3">
          <img src="/logo.png" alt="Da Polin" className="h-12 w-12 rounded-full shadow-sm" />
          <span className="font-serif text-2xl text-ink">Da <span className="italic text-terra">Polin</span></span>
        </Link>
        <nav className="flex flex-wrap justify-center gap-6 text-xs tracking-[0.2em] uppercase">
          {links.map((l) => (
            <Link key={l.key} to={l.to} data-testid={l.testid} className="text-ink/60 hover:text-terra transition-colors duration-300">
              {t(l.key)}
            </Link>
          ))}
        </nav>
        <p className="text-xs text-muted2 text-center" data-testid="footer-note">© {new Date().getFullYear()} Da Polin — {t("footer_note")}</p>
      </div>
    </footer>
  );
};
